import React from 'react'
import PropTypes from 'prop-types'
// import { useSelector } from 'react-redux'
// import ErrorHandle from '../../../ErrorHandle'
// import { ProfileApis } from '../../API/Login/ProfileApi'
// import { couchServiceApi } from '../../API/CouchService/couchServiceApi.js'
// import { newFormatDate } from '../../utils/GeneralUtils.js'
// import ErrorHandle from '../ErrorHandle.js'

const TransactionsTableBodyScreen = ({ requestObject }) => {
  // const handleReadRequest = () => {
  //   const reqObject = {
  //     fre8ProAccessToken: frProUser?.fre8ProAccessToken,
  //     couchId: requestObject?.couchId,
  //     couchBookingId: requestObject?.couchBookingId,
  //   }
  //   couchServiceApi
  //     .readRequestHost(reqObject)
  //     .then((res) => {})
  //     .catch((error) => {
  //       let customMessage = 'guest request reading api failed'
  //       let type = 'Couch Services'
  //       let color = 'red'
  //       ErrorHandle(error, setToasts, customMessage, type, color)
  //     })
  //     .finally(() => {})
  // }

  console.log('=======requestObject---->', requestObject)
  return (
    <tr>
      <td>
        <div className="d-flex gap-2 justify-content-start ">
          <input
            className="form-check-input align-self-center m-0"
            type="checkbox"
            value=""
            id="Phoenix"
          />
          <label className="form-check-label" htmlFor="Phoenix">
            <h6 className="m-0" style={{ cursor: 'pointer' }}>
              {requestObject?.logId}
            </h6>
          </label>
        </div>
      </td>
      <td>
        <p className="mb-0">{requestObject?.loginTime}</p>
        {/* <p className="mb-0">{newFormatDate(requestObject?.loginTime)}</p> */}
        {/* <p className="mb-0">{newFormatDate(requestObject?.checkOutDate)}</p> */}
      </td>
      <td className="text-lowercase" style={{ padding: '0 2rem' }}>
        {requestObject?.logoutTime}
      </td>
      <td>
        {requestObject?.repeatCustomer && (
          <button
            className="p-0 owner-operator-btn repeat_customer px-1"
            style={{ backgroundColor: '#ECFDF3' }}>
            <span className="me-2 online stclrx bg-success"></span>
            Repeat customer
          </button>
        )}
        <p style={{ width: '200px' }} className="custom-ellipsis">
          {requestObject?.computerId}
        </p>
      </td>
      <td>{requestObject?.activityTime}</td>
    </tr>
  )
}

export default TransactionsTableBodyScreen

TransactionsTableBodyScreen.propTypes = {
  requestObject: PropTypes.object,
}
